var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.297 209.747C560.481 178.91 534.484 145.615 514.126 135.09C528.643 163.201 538.719 193.391 543.997 224.587L544.05 225.082C510.702 141.977 454.172 108.415 407.978 35.4325C405.641 31.7415 403.305 28.0429 401.029 24.1388C399.728 21.909 398.686 19.8999 397.78 18.0506C395.864 14.341 394.388 10.4205 393.381 6.36874C393.382 6.18178 393.315 6.00085 393.191 5.86049C393.068 5.72013 392.897 5.63015 392.711 5.60771C392.53 5.55785 392.338 5.55785 392.156 5.60771C392.118 5.60771 392.057 5.67621 392.011 5.69143C391.966 5.70665 391.867 5.77514 391.798 5.80558L391.912 5.60771C317.826 48.9865 292.674 129.275 290.391 169.458C260.794 171.487 232.496 182.39 209.189 200.744C206.758 198.685 204.217 196.759 201.578 194.975C194.858 171.451 194.572 146.555 200.749 122.883C173.541 136.062 149.365 154.747 129.752 177.753H129.615C117.926 162.936 118.748 114.078 119.417 103.872C115.959 105.262 112.658 107.014 109.57 109.1C99.2503 116.465 89.6033 124.729 80.7418 133.796C70.6435 144.034 61.4206 155.1 53.1696 166.878V166.924V166.87C34.2087 193.747 20.7588 224.113 13.596 256.215L13.2002 258.164C12.6447 260.759 10.6432 273.757 10.3007 276.581C10.3007 276.801 10.255 277.007 10.2322 277.227C7.65039 290.647 6.05052 304.237 5.44531 317.889V319.411C5.57566 393.22 33.372 464.299 83.3472 518.615C133.322 572.931 201.845 606.538 275.388 612.802C348.93 619.066 422.149 597.531 480.59 552.449C539.032 507.367 578.448 442.013 591.059 369.289C591.554 365.484 591.957 361.717 592.398 357.874C598.474 307.66 591.897 256.725 573.266 209.701L573.297 209.747ZM233.344 440.644C234.721 441.306 236.015 442.021 237.431 442.653L237.636 442.782C236.205 442.097 234.775 441.384 233.344 440.644ZM544.058 225.165V224.884L544.111 225.196L544.058 225.165Z",
    fill: "url(#paint0_linear_4445_6183)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M573.298 209.798C560.482 178.961 534.486 145.666 514.128 135.141C528.645 163.252 538.721 193.442 543.998 224.638V224.92L544.052 225.232C566.79 290.293 563.502 361.624 534.874 424.317C501.069 496.851 419.273 571.196 291.191 567.543C152.836 563.624 30.9187 460.923 8.16381 326.449C4.01619 305.239 8.16381 294.485 10.249 277.248C7.40469 290.637 5.81738 304.263 5.50781 317.948V319.47C5.63816 393.279 33.4345 464.357 83.4097 518.674C133.385 572.99 201.907 606.597 275.45 612.861C348.993 619.125 422.212 597.59 480.653 552.508C539.094 507.425 578.511 442.072 591.122 369.348C591.616 365.543 592.02 361.776 592.461 357.933C598.536 307.719 591.959 256.783 573.329 209.76L573.298 209.798Z",
    fill: "url(#paint1_radial_4445_6183)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M573.298 209.798C560.482 178.961 534.486 145.666 514.128 135.141C528.645 163.252 538.721 193.442 543.998 224.638V224.92L544.052 225.232C566.79 290.293 563.502 361.624 534.874 424.317C501.069 496.851 419.273 571.196 291.191 567.543C152.836 563.624 30.9187 460.923 8.16381 326.449C4.01619 305.239 8.16381 294.485 10.249 277.248C7.40469 290.637 5.81738 304.263 5.50781 317.948V319.47C5.63816 393.279 33.4345 464.357 83.4097 518.674C133.385 572.99 201.907 606.597 275.45 612.861C348.993 619.125 422.212 597.59 480.653 552.508C539.094 507.425 578.511 442.072 591.122 369.348C591.616 365.543 592.02 361.776 592.461 357.933C598.536 307.719 591.959 256.783 573.329 209.76L573.298 209.798Z",
    fill: "url(#paint2_radial_4445_6183)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429.901 244.382C430.54 244.831 431.134 245.28 431.735 245.729C424.326 232.591 415.103 220.563 404.338 209.999C312.634 118.294 380.312 11.2172 391.72 5.73774L391.834 5.57031C317.748 48.9491 292.596 129.238 290.312 169.42C293.752 169.184 297.162 168.895 300.678 168.895C326.963 168.946 352.765 175.956 375.463 189.212C398.16 202.468 416.943 221.498 429.901 244.367V244.382Z",
    fill: "url(#paint3_radial_4445_6183)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300.85 262.772C300.363 270.109 274.443 295.413 265.379 295.413C181.513 295.413 167.891 346.151 167.891 346.151C171.604 388.875 201.376 424.081 237.365 442.65C239.009 443.502 240.676 444.271 242.342 445.024C245.229 446.303 248.116 447.485 251.003 448.571C263.354 452.941 276.291 455.437 289.382 455.976C436.413 462.87 464.876 280.177 358.78 227.133C383.807 223.877 409.152 230.031 429.899 244.401C416.94 221.532 398.158 202.503 375.46 189.247C352.763 175.99 326.96 168.981 300.675 168.93C297.175 168.93 293.75 169.219 290.31 169.455C260.713 171.484 232.415 182.387 209.108 200.741C213.606 204.546 218.682 209.63 229.374 220.17C249.389 239.888 300.721 260.314 300.835 262.712L300.85 262.772Z",
    fill: "url(#paint4_radial_4445_6183)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.85 262.772C300.363 270.109 274.443 295.413 265.379 295.413C181.513 295.413 167.891 346.151 167.891 346.151C171.604 388.875 201.376 424.081 237.365 442.65C239.009 443.502 240.676 444.271 242.342 445.024C245.229 446.303 248.116 447.485 251.003 448.571C263.354 452.941 276.291 455.437 289.382 455.976C436.413 462.87 464.876 280.177 358.78 227.133C383.807 223.877 409.152 230.031 429.899 244.401C416.94 221.532 398.158 202.503 375.46 189.247C352.763 175.99 326.96 168.981 300.675 168.93C297.175 168.93 293.75 169.219 290.31 169.455C260.713 171.484 232.415 182.387 209.108 200.741C213.606 204.546 218.682 209.63 229.374 220.17C249.389 239.888 300.721 260.314 300.835 262.712L300.85 262.772Z",
    fill: "url(#paint5_radial_4445_6183)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.363 190.965C197.753 192.488 199.724 193.812 201.451 195.007C194.731 171.483 194.445 146.587 200.622 122.914C173.414 136.094 149.238 154.778 129.625 177.784C131.063 177.746 173.849 176.978 195.363 190.965Z",
    fill: "url(#paint6_radial_4445_6183)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07789 326.45C30.8403 460.924 152.75 563.664 291.106 567.545C419.187 571.167 500.998 496.815 534.788 424.319C563.416 361.626 566.704 290.294 543.966 225.233V224.951C543.966 224.731 543.92 224.601 543.966 224.67L544.019 225.164C554.483 293.482 519.735 359.639 465.405 404.463L465.237 404.844C359.378 491.069 258.084 456.853 237.613 442.896C236.182 442.211 234.751 441.498 233.32 440.757C171.608 411.259 146.106 355.065 151.586 306.816C136.937 307.032 122.539 302.995 110.138 295.194C97.7366 287.394 87.8637 276.164 81.7153 262.866C97.9161 252.942 116.388 247.331 135.372 246.569C154.356 245.807 173.218 249.919 190.162 258.513C225.088 274.366 264.83 275.928 300.892 262.866C300.778 260.469 249.447 240.035 229.432 220.324C218.739 209.784 213.663 204.708 209.165 200.895C206.734 198.836 204.194 196.911 201.555 195.127C199.805 193.932 197.833 192.638 195.467 191.085C173.952 177.098 131.167 177.866 129.752 177.904H129.615C117.925 163.087 118.747 114.229 119.417 104.023C115.959 105.413 112.658 107.166 109.569 109.252C99.2497 116.617 89.6027 124.881 80.7412 133.947C70.6068 144.157 61.3456 155.197 53.0549 166.953C34.094 193.83 20.644 224.188 13.4812 256.291C13.3366 256.892 2.85722 302.706 8.02462 326.465L8.07789 326.45Z",
    fill: "url(#paint7_radial_4445_6183)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M404.367 210.003C415.134 220.579 424.358 232.62 431.764 245.771C433.385 246.996 434.899 248.214 436.185 249.393C503.057 311.037 468.019 398.175 465.409 404.34C519.731 359.583 554.45 293.381 544.023 225.04C510.66 141.86 454.069 108.298 407.951 35.3153C405.615 31.6243 403.278 27.9257 401.003 24.0216C399.701 21.7918 398.659 19.7827 397.753 17.9334C395.838 14.2238 394.361 10.3033 393.354 6.25156C393.356 6.06459 393.288 5.88367 393.165 5.7433C393.041 5.60294 392.87 5.51296 392.685 5.49053C392.503 5.44066 392.311 5.44066 392.129 5.49053C392.091 5.49053 392.03 5.55902 391.985 5.57424C391.939 5.58946 391.84 5.65795 391.771 5.68839C380.364 11.0993 312.7 118.245 404.405 209.873L404.367 210.003Z",
    fill: "url(#paint8_radial_4445_6183)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M436.187 249.417C434.901 248.237 433.387 247.02 431.766 245.794C431.165 245.345 430.571 244.896 429.932 244.447C409.185 230.077 383.84 223.923 358.813 227.18C464.901 280.223 436.439 462.871 289.415 456.022C276.324 455.484 263.388 452.988 251.036 448.617C248.149 447.536 245.262 446.354 242.376 445.07C240.709 444.309 239.042 443.548 237.398 442.696L237.604 442.825C258.106 456.821 359.369 491.014 465.228 404.774L465.396 404.393C468.037 398.229 503.075 311.091 436.172 249.447L436.187 249.417Z",
    fill: "url(#paint9_radial_4445_6183)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M167.889 346.07C167.889 346.07 181.504 295.332 265.377 295.332C274.441 295.332 300.385 270.027 300.849 262.691C264.786 275.753 225.045 274.191 190.119 258.338C173.175 249.744 154.312 245.632 135.329 246.394C116.345 247.156 97.8727 252.767 81.6719 262.691C87.8202 275.989 97.6932 287.219 110.094 295.019C122.496 302.82 136.893 306.857 151.542 306.64C146.078 354.867 171.573 411.054 233.277 440.582C234.654 441.244 235.948 441.959 237.364 442.591C201.344 423.984 171.603 388.794 167.889 346.092V346.07Z",
    fill: "url(#paint10_radial_4445_6183)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.281 209.747C560.466 178.91 534.469 145.615 514.111 135.09C528.628 163.201 538.704 193.391 543.982 224.587L544.035 225.082C510.687 141.977 454.157 108.415 407.962 35.4325C405.626 31.7415 403.29 28.0429 401.014 24.1388C399.713 21.909 398.67 19.8999 397.765 18.0506C395.849 14.341 394.373 10.4205 393.366 6.36874C393.367 6.18178 393.3 6.00085 393.176 5.86049C393.053 5.72013 392.882 5.63015 392.696 5.60771C392.514 5.55785 392.322 5.55785 392.141 5.60771C392.103 5.60771 392.042 5.67621 391.996 5.69143C391.95 5.70665 391.851 5.77514 391.783 5.80558L391.897 5.60771C317.811 48.9865 292.659 129.275 290.376 169.458C293.815 169.222 297.225 168.933 300.741 168.933C327.026 168.984 352.828 175.993 375.526 189.25C398.223 202.506 417.006 221.535 429.964 244.404C409.217 230.034 383.872 223.88 358.846 227.136C464.933 280.18 436.471 462.828 289.447 455.979C276.356 455.44 263.42 452.944 251.068 448.574C248.181 447.493 245.295 446.311 242.408 445.027C240.741 444.266 239.074 443.505 237.431 442.653L237.636 442.782C236.205 442.097 234.775 441.384 233.344 440.644C234.721 441.306 236.015 442.021 237.431 442.653C201.411 424.038 171.67 388.848 167.956 346.154C167.956 346.154 181.571 295.416 265.444 295.416C274.508 295.416 300.452 270.112 300.916 262.775C300.802 260.378 249.47 239.945 229.455 220.234C218.762 209.694 213.686 204.617 209.189 200.805C206.758 198.746 204.217 196.82 201.578 195.036C194.858 171.512 194.572 146.616 200.749 122.944C173.541 136.123 149.365 154.807 129.752 177.814H129.615C117.926 162.997 118.748 114.138 119.417 103.933C115.959 105.323 112.658 107.075 109.57 109.161C99.2503 116.526 89.6033 124.79 80.7418 133.857C70.6435 144.095 61.4206 155.161 53.1696 166.939C34.2087 193.816 20.7588 224.174 13.596 256.276L13.2002 258.224C12.6447 260.82 10.1561 274.001 9.79841 276.832C7.52217 290.438 6.0685 304.169 5.44531 317.95V319.472C5.57566 393.281 33.372 464.36 83.3472 518.676C133.322 572.992 201.845 606.599 275.388 612.863C348.93 619.127 422.149 597.592 480.59 552.51C539.032 507.428 578.448 442.074 591.059 369.35C591.554 365.545 591.957 361.778 592.399 357.935C598.474 307.721 591.897 256.786 573.266 209.762L573.281 209.747Z",
    fill: "url(#paint11_linear_4445_6183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4445_6183",
    x1: 534.256,
    y1: 99.8228,
    x2: 44.5852,
    y2: 572.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(515.308 74.1059) scale(614.913 614.913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.998 325.246) scale(614.913 614.913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.082 -62.9225) scale(445.432 445.432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.507 485.07) scale(292.769 292.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316.741 272.468) rotate(-13.5916) scale(155.251 181.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.381 51.2401) scale(210.653 210.654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(446.782 -85.7246) scale(898.778 898.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.129 -35.902) rotate(83.976) scale(658.638 432.258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.415 127.347) scale(561.032 561.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4445_6183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.976 157.79) scale(614.076 614.076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4445_6183",
    x1: 528.304,
    y1: 97.3113,
    x2: 111.716,
    y2: 513.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxIcon);
export default __webpack_public_path__ + "static/media/firefox_icon.48422f597844f4ce5818c94ff71935b1.svg";
export { ForwardRef as ReactComponent };